/*************************************************/
/* INFORMATION-COMPONENT                         */
/*************************************************/

export function information() {
    const components = document.querySelectorAll('.information');

    components.forEach(component => {
        const informationMarkers = component.querySelectorAll('.information__information-marker');
        const accordionHeads = component.querySelectorAll('.accordion__item-head');
        const activeClass = 'accordion__item--active';

        informationMarkers.forEach(marker => {
            marker.addEventListener('click', event => {
                const dataInformation = marker.dataset.information;
                const accordionItem = component.querySelector(`.accordion__item[data-information="${dataInformation}"]`);
                const accordionHead = accordionItem?.querySelector('.accordion__item-head');

                if (accordionItem && !accordionItem.classList.contains(activeClass)) {
                    informationMarkers.forEach(m => {
                        m.style.opacity = '1';
                    });

                    accordionHead?.click();
                    marker.style.opacity = '0';
                } else {
                    accordionHead?.click();
                }

                event.stopPropagation();
            });
        });

        accordionHeads.forEach(head => {
            head.addEventListener('click', event => {
                const accordionItem = head.closest('.accordion__item');
                const dataInformation = accordionItem?.dataset.information;
                const connectedMarkers = component.querySelectorAll(`.information__information-marker[data-information="${dataInformation}"]`);

                if (connectedMarkers.length > 0) {
                    informationMarkers.forEach(marker => {
                        if (!accordionItem.classList.contains(activeClass)) {
                            marker.style.opacity = '1';
                        }
                    });

                    connectedMarkers.forEach(marker => {
                        if (!accordionItem.classList.contains(activeClass)) {
                            marker.style.opacity = '0';
                        } else {
                            marker.style.opacity = '1';
                        }
                    });
                }

                event.stopPropagation();
            });
        });
    });
}

